import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  min-height: 100vh;
  color: var(--primary);
  background-color: var(--secondary);
`;

export const DateBox = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
`;

export const DateText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 30rem;
  gap: 1rem;
  color: var(--secondary);
  background-color: var(--darkBlue);
`;

export const DateLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20rem;
  height: 100%;
  color: var(--secondary);
  margin-right: 0.3rem;
  border-radius: 2rem 0 0 2rem;
  background-color: var(--darkBlue);
`;
  
export const DateRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20rem;
  height: 100%;
  color: var(--secondary);
  margin-left: 0.3rem;
  border-radius: 0 2rem 2rem 0;
  background-color: var(--darkBlue);
`;

export const DateModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 30rem;
  min-height: 52rem;
  gap: 2rem;
  color: var(--primary);
  margin-left: 0.3rem;
  background-color: var(--secondary);
`;

export const DateReserve = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  margin: 1rem;
  border: 1px solid var(--primary);
`;

export const RoomTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: var(--secondary);
  font: var(--title);
  background-color: var(--softBlue);
  margin: 0 1rem 1rem 1rem;
  width: 100%;
`;

export const RoomReserve = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  width: 100%;
`;

export const Reserve = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: ${(props) =>
    props.full ? css`100%` : css`33%`};
  height: 15rem;
  margin: 1rem;
  flex-wrap: nowrap;
  ${(props) =>
    !props.full && css`border: 1px solid var(--primary);`};
  div {
  }
`;

export const ReserveTitle = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  color: var(--secondary);
  background-color: var(--hardBlue);
`;
export const ReserveText = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  margin: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`;